import type { UnknownAction } from 'redux';

import { resourceStoreTypes, resourceUpserters } from '../core';
import * as actions from './taxLineItemsActions';
import type { TaxLineItemProps } from './taxLineItemsTypes';

const mkTaxLineItemsStore = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<TaxLineItemProps>();
const initialState = mkTaxLineItemsStore();

function taxLineItemsReducer(state = initialState, action: UnknownAction): typeof state {
  switch (true) {
    case actions.getTaxLineItems.match(action):
      return state.set('isLoading', true);
    case actions.getTaxLineItemsSuccess.match(action):
      return resourceUpserters.upsertResources(state, action.payload);
    case actions.getTaxLineItemsFailure.match(action):
      return resourceUpserters.completeWithError<TaxLineItemProps>(state, action.payload);
    default:
      return state;
  }
}

export default taxLineItemsReducer;
